<div [ngClass]="'relative flex' + class">
  <input class="w-full leading-4 text-base font-medium border border-[#999999] rounded-[6px]"
         [ngClass]="{
         'px-4' : inputType !== 'number',
         'pl-4 pr-20' : inputType === 'number',
         'bg-[#999999]/15 text-black/30' : disabled,
         'bg-[#FAFAFA]' : !disabled,

         }"
    [type]="inputType === 'password' ? 'password' : 'text' "
    [(ngModel)]="value"
    (input)="onInputChange()"
    [title]="title"
    [placeholder]="placeholder"
    [style.width]="width"
    [style.height]="height"
    [attr.maxlength]="maxLength"
    (keydown)="onKeyDown($event)"
    [disabled]="disabled"
    >
  @if (showEye) {
    <div (click)="changeInputType()" [title]="showPassword ? 'Ausblenden' : 'Anzeigen'" class="absolute cursor-pointer right-4 top-1/2 transform -translate-y-1/2">
      <fa-icon [icon]="showPassword ? 'eye-slash' : 'eye'"></fa-icon>
    </div>
  }
</div>


